import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import Keycloak from 'keycloak-js';
import { JkuUserService } from './jku-user.service';
import { jkuIdpAlias } from '../auth/login-options';

/**
 * Restricts the JKU webshop to JKU-SSO sessions. "JKU user" = authenticated
 * through the JKU IdP broker, identified by the `jku_account` (AK/K number) or `user_type` claim
 * (see {@link JkuUserService.isJkuSso}); both are empty for local / self-registered parkers.
 *
 * - JKU user            → allow.
 * - Not signed in       → redirect straight to the JKU IdP so a JKU user can sign in.
 * - Signed in, non-JKU  → block; send home.
 */
export const canActivateJkuSso: CanActivateFn = (): boolean | UrlTree => {
  const jkuUser = inject(JkuUserService);
  const keycloak = inject(Keycloak);
  const router = inject(Router);

  if (jkuUser.isJkuSso()) {
    return true;
  }

  if (!keycloak.authenticated) {
    keycloak.login({ idpHint: jkuIdpAlias(), redirectUri: window.location.href });
    return false;
  }

  return router.parseUrl('/');
};
